import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const HeartUsersIcon: FC<IconProps> = (props) => (
  <Icon
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    boxSize="32px"
    viewBox="0 0 45 35"
    fill="phthalo"
    stroke="phthalo"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit={10}
    {...props}
  >
    <path
      d="M3.3 17.1c-.2-.6-.4-1.1-.6-1.7-.3-1.1-.5-2.2-.5-3.2 0-2.9 1-5.3 3-7.3s4.4-3 7.3-3c1.7 0 3.4.4 5 1.2 1.6.8 3 2 4.2 3.5l.9 1.2.9-1.2c1.2-1.5 2.6-2.7 4.2-3.5 1.6-.8 3.3-1.2 5-1.2 2.9 0 5.3 1 7.3 3s3 4.4 3 7.3c0 1-.2 2.1-.5 3.2-.2.6-.4 1.2-.6 1.7"
      strokeWidth={3}
      fill="none"
    />
    <path
      d="M13.8 32.7c-.2 0-.3-.1-.4-.1-.1-.1-.1-.2-.1-.4v-.8c0-1.4.7-2.4 2.2-3.3 1.6-1 3.9-1.5 6.6-1.5 2.8 0 5 .5 6.7 1.5 1.5.9 2.2 1.9 2.2 3.3v.8c0 .2-.1.3-.1.4-.1.1-.2.1-.4.1H13.8z"
      fill="none"
      strokeWidth={3}
    />
    <circle cx={22.7} cy={18.6} r={3.5} />
    <path
      strokeWidth={1}
      d="M2.6 33.3c-.5 0-.8-.2-1.2-.5-.2-.3-.4-.7-.4-1.1V31c0-1.3.6-2.3 1.9-3.1 1.3-.8 3-1.2 5.1-1.2h1.1c.3 0 .7.1 1 .1-.4.5-.6 1.1-.8 1.8-.2.6-.2 1.3-.2 2v2.6l-6.5.1zM35.9 33.3v-2.6c0-.7-.1-1.4-.3-2-.2-.6-.4-1.2-.8-1.8.3-.1.6-.1 1-.1h1.1c2.1 0 3.8.4 5.1 1.2s2 1.8 2 3v.7c0 .5-.2.8-.5 1.2-.3.3-.7.5-1.2.5h-6.4zM37 25c-.9 0-1.6-.3-2.3-.9-.6-.6-.9-1.4-.9-2.3 0-.9.3-1.6.9-2.3.6-.6 1.4-.9 2.3-.9.9 0 1.6.3 2.3.9.6.6.9 1.4.9 2.3 0 .9-.3 1.6-.9 2.3-.7.5-1.4.9-2.3.9z"
    />

    <path
      strokeWidth={1}
      d="M7.6 25c-.9 0-1.6-.4-2.2-1-.6-.6-.9-1.4-.9-2.3 0-.9.3-1.6.9-2.3.6-.6 1.4-.9 2.3-.9.9 0 1.6.3 2.3.9.6.6.9 1.4.9 2.3 0 .9-.3 1.6-.9 2.3-.7.6-1.5 1-2.4 1z"
    />
  </Icon>
)
export default HeartUsersIcon
